import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 147.58 147.58"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { fill: "currentColor" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M105.57 42.86H44.35c-6.69 0-12.1 5.42-12.1 12.1v37.67c0 6.68 5.41 12.1 12.1 12.1h61.22c6.68 0 12.1-5.42 12.1-12.1V54.96c0-6.68-5.42-12.1-12.1-12.1M85.06 76.51l-17.5 8.75c-2.01 1-4.39-.46-4.39-2.72V65.05c0-2.26 2.38-3.72 4.39-2.72l17.5 8.75c2.23 1.12 2.23 4.31 0 5.43" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M73.79 147.58c-19.71 0-38.24-7.68-52.18-21.61C7.67 112.03 0 93.5 0 73.79s7.68-38.24 21.61-52.18C35.55 7.67 54.08 0 73.79 0s38.24 7.68 52.18 21.61c13.94 13.94 21.61 32.47 21.61 52.18s-7.68 38.24-21.61 52.18-32.47 21.61-52.18 21.61m0-142.05c-18.23 0-35.38 7.1-48.27 19.99S5.53 55.56 5.53 73.79s7.1 35.38 19.99 48.27 30.03 19.99 48.27 19.99 35.38-7.1 48.27-19.99 19.99-30.03 19.99-48.27-7.1-35.38-19.99-48.27S92.02 5.53 73.79 5.53" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }